import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import "../styles/page-verticals.css";

const CTA_LABEL = "Begin a partnership";




/* ──────── nav ──────── */



/* ──────── verticals hero ──────── */

function VerticalsHero() {
  return (
    <section className="page-hero" id="top" data-screen-label="01 Verticals hero">
      <div className="wrap">
        <span className="eyebrow">Industries</span>
        <h1 className="page-hero-h"><span className="accent ink">Growth that scales</span> across industries, year on year.</h1>
        <p className="page-hero-sub">We partner with businesses in industries where performance, compliance, and lead quality matter. Our model is designed for sectors that demand structured acquisition, consistent volume, and measurable revenue impact. These are the verticals where we deliver.</p>
      </div>
    </section>);

}

/* ──────── verticals grid ──────── */

function Verticals() {
  const items = [
  { n: "01", name: "Insurance",
    body: "We generate qualified enquiries across health, life, home, business, and every other insurance line. These are products where eligibility rules and compliance leave no room for sloppy targeting, so every enquiry is screened on the criteria that matter before it reaches your team.",
    lands: "What lands is a prospect worth quoting." },
  { n: "02", name: "Financing",
    body: "We deliver pre-qualified enquiries across mortgages, refinancing, car loans, business finance, and other lending products. Targeting is built around real borrower intent, so lenders get prospects screened for genuine funding demand before they reach you.",
    lands: "What lands is someone ready to move on an application." },
  { n: "03", name: "Legal",
    body: "We generate qualified case enquiries across personal injury, compensation claims, class actions, and other legal matters. These run on strict eligibility, so every enquiry is screened against clear case criteria before it reaches you.",
    lands: "What lands is a prospect who meets the standard, not one that falls apart on first contact." },
  { n: "04", name: "E-Commerce",
    body: "We drive high-intent customer acquisition for product businesses across competitive categories. The model ties our performance to your sales, not your clicks, with campaigns and landing environments built to convert demand into revenue.",
    lands: "What lands is paying customers, with margin that holds as you scale." },
  { n: "05", name: "Energy",
    body: "We generate qualified enquiries for solar and energy providers, from residential installs to commercial supply. Targeting is built around genuine switching and install intent, so providers get prospects screened on the criteria that decide eligibility before they reach you.",
    lands: "What lands is someone ready to act, not just price-curious." },
  { n: "06", name: "Home Services",
    body: "We generate appointment-ready enquiries for home services, across renovation, roofing, plumbing, and other trades. Campaigns are built for immediate response, so providers get homeowners ready to book, screened before they reach you.",
    lands: "What lands is a job worth quoting, not passive interest." },
  { n: "07", name: "Business Sales",
    body: "We generate qualified enquiries from business owners actively weighing a sale, across industries and deal sizes. Intent is screened before it reaches you, so brokers and advisors get owners genuinely ready to value, list, or sell, not ones testing the water.",
    lands: "What lands is a seller worth a conversation." },
  { n: "08", name: "Market Research",
    body: "We deliver targeted participant acquisition for paid research panels, surveys, and consumer studies, medical and non-medical alike. Precision targeting and qualification controls screen respondents before they reach you, so they fit the demographic and behavioral profile a study calls for.",
    lands: "What lands is a participant who qualifies." }];


  return (
    <section className="verts" id="vert-current" data-screen-label="02 Verticals">
      <div className="wrap">
        <div className="verts-head">
          <div>
            <span className="eyebrow">Where we work</span>
          </div>
          <div>
            <h2>Eight verticals, <span className="accent ink">one performance model.</span></h2>
          </div>
        </div>
        <div className="verts-grid">
          {items.map((it, i) =>
          <div className="vert" key={i}>
              <span className="vert-num"><b>{it.n}</b></span>
              <h3 className="vert-name">{it.name}</h3>
              <p className="vert-body">{it.body}</p>
              <p className="vert-lands">{it.lands}</p>
            </div>
          )}
        </div>
      </div>
    </section>);

}

/* ──────── verticals closing ──────── */

function VerticalsClosing({ ctaLabel, onCta }) {
  return (
    <section className="closing" data-tone="dark" data-screen-label="03 Closing CTA">
      <div className="wrap">
        <div className="closing-grid">
          <div>
            <span className="eyebrow">Next step</span>
          </div>
          <div>
            <h2>Start the <em>conversation.</em></h2>
            <p className="closing-side" style={{ marginTop: 28 }}>
              We already know what good looks like in your industry. Let's prove it on yours.
            </p>
            <div className="closing-foot">
              <button className="link-btn-primary" onClick={onCta}>
                {ctaLabel} <span className="arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

}

/* ──────── footer ──────── */

function VerticalsPage() {
  const [csOpen, setCsOpen] = useState(false);

  useEffect(() => {document.body.setAttribute("data-density", "standard");}, []);

  const openCs = (e) => {if (e) e.preventDefault();setCsOpen(true);};

  return (
    <div className="page page-verticals">
      <Nav onCta={openCs} ctaLabel={CTA_LABEL} />
      <VerticalsHero />
      <Verticals />
      <VerticalsClosing ctaLabel={CTA_LABEL} onCta={openCs} />
      <Footer onContact={openCs} />

      <ContactModal open={csOpen} onClose={() => setCsOpen(false)} />
    </div>);

}

export default VerticalsPage;
